import { columns } from "@/components/tables/builds/columns";
import { DataTable } from "@/components/tables/builds/table";
import { httpClient } from "@/lib/http-client";
import { HydrationBoundary, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "@/lib/paraglide-react";
type LoaderData = {
  dehydratedState: DehydratedState;
  id: string;
  offer: SingleOffer | null;
};
import { Route } from "/app/src/routes/{-$locale}/offers/$id/builds.tsx";
function BuildsPage() {
  const {
    t
  } = useTranslation();
  const {
    id
  } = Route.useLoaderData() as LoaderData;
  const [page, setPage] = useState({
    pageIndex: 0,
    pageSize: 20
  });
  const [filters, setFilters] = useState<ColumnFiltersState>([]);
  const {
    data: builds,
    isLoading,
    isError
  } = useQuery({
    queryKey: ["offer-builds", {
      id
    }],
    queryFn: () => httpClient.get<Build[]>(`/offers/${id}/builds`)
  });
  if (isLoading) {
    return <div>{t("offerDetail.common.loading")}</div>;
  }
  if (isError) {
    return <section id="offer-builds" className="h-full w-full">
        <h2 className="text-xl md:text-2xl font-bold mb-4">{t("offerDetail.builds.title")}</h2>
        <div>{t("offerDetail.common.somethingWentWrong")}</div>
      </section>;
  }

  // Filter builds based on the current filters
  const filteredBuilds = builds?.filter(build => {
    return filters.every(filter => {
      if (filter.id === "labelName" && Array.isArray(filter.value)) {
        const platform = build.labelName.split("-")[1];
        return filter.value.includes(platform);
      }
      const value = build[filter.id as keyof Build];
      if (Array.isArray(filter.value)) {
        return filter.value.includes(value);
      }
      return String(value).toLowerCase().includes(String(filter.value).toLowerCase());
    });
  }) ?? [];
  return <section id="offer-builds" className="h-full w-full">
      <h2 className="text-xl md:text-2xl font-bold mb-4">{t("offerDetail.builds.title")}</h2>
      <DataTable<Build, unknown> columns={columns} data={filteredBuilds} setPage={setPage} page={page} total={filteredBuilds.length} filters={filters} setFilters={setFilters} />
    </section>;
}
const SplitComponent = () => {
  const {
    dehydratedState
  } = Route.useLoaderData() as LoaderData;
  return <HydrationBoundary state={dehydratedState}>
        <BuildsPage />
      </HydrationBoundary>;
};
export { SplitComponent as component };